import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import * as ACTIONS_CREATOR from '../redux/ShoppingCartActionsCreator';
import * as CONST from '../constants';
import {Formik, Form} from 'formik';
import {validateGiftCard} from '../lib/validation';
import TextField from '../audi-ui-components/TextField';
import TextArea from '../audi-ui-components/TextArea';
import Button from '../audi-ui-components/Button';
import RadioFieldset from '../audi-ui-components/RadioFieldset';

const mapStateToProps = (state) => {
    return {
        cartId: state.shoppingCart.cart.id,
    };
};

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchData: ACTIONS_CREATOR.fetchData,
    setShoppingCart: ACTIONS_CREATOR.setShoppingCart,
    setAlertMessage: ACTIONS_CREATOR.setAlertMessage,
}, dispatch);

class GiftCardEditForm extends Component {

    updateCartItem = (formData, actions) => {
        this.props.setAlertMessage(true, 'success', 'Adding Recipient details...');
        const url = `/1/cart/${this.props.cartId}/item/${this.props.cartItem.id}`;
        this.props.fetchData(url, 'PATCH', formData)
        .then(result => {
            this.props.setShoppingCart(result);
            this.props.setAlertMessage(false);
            this.props.close();
        })
        .catch(err => {
            err.then( errorObj => {
                if (errorObj.modelState) {
                    var fieldErrors = {};
                    var errorKeys = Object.keys(errorObj.modelState);
                    for (let i=0; i<errorKeys.length; i++) {
                        let key = errorKeys[i];
                        fieldErrors[`${key}`] = errorObj.modelState[`${key}`][0];
                    }
                    actions.setErrors(fieldErrors);
                }
                this.props.setAlertMessage(true, 'danger', errorObj.message);
            });
        });
    }

    render() {
        const {cartItem} = this.props;
        return (
            <div className="giftcard-edit-form">
                <Formik
                    initialValues={{
                        giftCardType: cartItem.giftCardType || 'Self',
                        recipientName: cartItem.recipientName || '',
                        recipientEmail: cartItem.recipientEmail || '',
                        senderMessage: cartItem.senderMessage || ''
                    }}
                    validate={validateGiftCard}
                    onSubmit={this.updateCartItem}
                  >
                    {({values, errors, touched, setFieldValue}) => (<Form>
                        <RadioFieldset
                            name="giftCardType"
                            title="Send to:"
                            className="mb-4"
                            options={[{label: 'Recipient', value: 'Recipient'}, {label: 'Myself', value: 'Self'}]}
                            value={values.giftCardType}
                            onChange={(v) => { setFieldValue('giftCardType', v); }} />
                        <fieldset className="aui-fieldset" style={{display: values.giftCardType === 'Recipient' ? 'block' : 'none'}}>
                            <legend className="aui-fieldset__legend">Recipient details</legend>
                            <TextField name="recipientName"
                                label="Recipient name*"
                                value={values.recipientName}
                                isInvalid={errors.recipientName && touched.recipientName}
                                invalidMessage="Please enter the recipient's name"
                                onChange= {(v) => { setFieldValue('recipientName', v); }}
                                className="mb-4"
                            />
                            <TextField name="recipientEmail"
                                label="Recipient email*"
                                value={values.recipientEmail}
                                isInvalid={errors.recipientEmail && touched.recipientEmail}
                                invalidMessage="Please enter the recipient's email address"
                                onChange= {(v) => { setFieldValue('recipientEmail', v); }}
                                className="mb-4"
                            />
                            <TextArea name="senderMessage"
                                label="Message"
                                value={values.senderMessage}
                                onChange={(v) => { setFieldValue('senderMessage', v);}}
                                className="mb-4"
                            />
                        </fieldset>
                        <div style={{textAlign: 'right'}}>
                          <Button variant="secondary" type="button" onClick={this.props.close}>Cancel</Button>
                          {` `}
                          <Button variant="primary" type="submit">Update</Button>
                        </div>
                    </Form>)}
                </Formik>
            </div>
        );
    }
}

GiftCardEditForm.propTypes = {
    close: PropTypes.func,
    cartItem: PropTypes.object,
    cartId: PropTypes.string,
    setShoppingCart: PropTypes.func,
    fetchData: PropTypes.func,
    setAlertMessage: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(GiftCardEditForm);
